
const fountainImg = "";

export default class Fountain {

	constructor (run) {

		this.run = run;
		this.active = true;
		this.run.notify('newfountain', this, run);
	}

	get entity () {

		return {
			id: { type: "fountain", no: 1 },
			name: "Fountain",
			img: fountainImg
		}
	}

	get choices () {

		/*if (this.run.champion.corruption)
			return [{
				type: "cleanse",
				value: this.run.worshipCorruption
			}]*/

		let choices = [
			{
				type: "rest",
				value: this.run.restHealing
			},
			{
				type: "worship",
				value: this.run.worshipExp
			},
			{
				type: "conjure"
			}
		]

		if (this.run.champion.getPassive("fountainpurify"))
			choices.push({ type: "purify" });
		if (this.run.champion.getPassive("fountainwish"))
			choices.push({ type: "wish" });

		return choices;
	}

	select (type) {

		if (!this.active)
			return;

		switch (type) {
		case "rest":
			this.run.champion.heal(this.run.restHealing);
			break;
		case "worship":
			this.run.champion.gainExp(this.run.worshipExp);
			break;
		case "conjure":
			this.run.cardChoice(true, 3, false, this.value);;
			break;
		case "cleanse":
			this.run.champion.loseCorruption(this.run.worshipCorruption);
			break;
		case "ponder":
			return;
		case "purify":
			this.run.changeMinDeckSize(-1);
			break;
		case "wish":
			this.run.champion.newRelic(this.run.generateRelic());
			break;
		default: break;
		}

		this.active = false;
		this.run.notify('usefountain', this)
	}

	serialize () {

		return {
			active: this.active
		}
	}

	static build (run, src) {

		let fountain = new Fountain(run);
		fountain.active = src.active;
		return fountain;
	}
}